'use strict';

module.exports = '3.25.1';



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch/src/version.js
// module id = 381
// module chunks = 0